module.exports = __webpack_public_path__ + "static/media/steakhouse_teen-dt-en.b89d4e2b.jpg";